// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The notebook widget factory token.
 */
export const INotebookWidgetFactory = new Token('@jupyterlab/notebook:INotebookWidgetFactory');
/* tslint:enable */
/* tslint:disable */
/**
 * The notebook tools token.
 */
export const INotebookTools = new Token('@jupyterlab/notebook:INotebookTools');
/* tslint:disable */
/**
 * The notebook tracker token.
 */
export const INotebookTracker = new Token('@jupyterlab/notebook:INotebookTracker');
//# sourceMappingURL=tokens.js.map